import type {
  DerivedEventLegacy,
  IndexDateVariableLegacy,
  SimpleEventLegacy,
  SubjectVariableLegacy,
} from '@verantos-dev/types-cohorts';

import type {
  CohortDefinitionStoreActions,
  CohortDefinitionStoreState,
  LegacyEntities,
} from '../types';

type Store = CohortDefinitionStoreState & CohortDefinitionStoreActions;
type SetState = (
  partial: Store | Partial<Store> | ((state: Store) => Store | Partial<Store>)
) => void;

export const createLegacyEntitiesSlice = (set: SetState) => ({
  simpleEvents: [] as SimpleEventLegacy[],
  derivedEvents: [] as DerivedEventLegacy[],
  indexDate: undefined as IndexDateVariableLegacy | undefined,
  subjectVariables: [] as SubjectVariableLegacy[],

  setLegacyEntities: (entities: LegacyEntities) =>
    set({
      simpleEvents: entities.simpleEvents,
      derivedEvents: entities.derivedEvents,
      indexDate: entities.indexDate,
      subjectVariables: entities.subjectVariables,
    }),
});
